<template>
  <div class="section">
    <div style="height: 100%;display: flex;flex-direction: column;">
      <div style="display: flex;justify-content: flex-end;margin-bottom: 5px">
        <el-button no="7" type="primary" @click="voyageCostAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button no="8" type="danger" @click="voyageCostDel">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
      <cargo-left-right-resize
        :left-style="{ width: '30%', }"
        :right-style="{ width: '70%',}"
        style="min-height:80%"
      >
        <template slot="left">
          <cargo-ag-grid
            no="6"
            config-module="150012"
            :grid-options="voyageGrid.gridOptions"
            :column-defs="voyageGrid.columnDefs"
            :row-data="voyageGrid.rowData"
            style="height: 100%;"
            @gridReady="params=>{voyageGrid.gridApi=params.api}"
          />
        </template>
        <template slot="right">
          <cargo-ag-grid
            no="9"
            config-module="150013"
            :grid-options="voyageCostGrid.gridOptions"
            :column-defs="voyageCostGrid.columnDefs"
            :row-data="voyageCostGrid.rowData"
            style="height: 100%;"
            @gridReady="params=>{voyageCostGrid.gridApi=params.api}"
          />
        </template>
      </cargo-left-right-resize>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import {
  CURRENCY_RMB,
  FEE_STANDARDS,
  FEE_STANDARDS_WEIGHT,
  UNIT_PRICE,
  UNITS,
  WEEKS
} from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'AirlineProductVoyageCost',
  components: { CargoLeftRightResize },
  props: {
    form: { type: Object, default: () => {} }
  },
  data() {
    return {
      selectedItem: null,
      delVoyageCostKeys: [],
      voyageGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          onRowClicked: (event) => {
            const data = event.data
            this.selectedItem = data
            if (!data) {
              this.voyageCostGrid.rowData = []
            } else {
              if (!data.voyageCosts) {
                data.voyageCosts = []
              }
              // 切换费用
              this.voyageCostGrid.rowData = data.voyageCosts
            }
          }
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
            field: 'serialNumber',
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1
          }, {
            headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
            field: 'voyage',
            valueFormatter: params => {
              return ColumnUtils.showTypeLabelFunc(params.value, WEEKS)
            },
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      voyageCostGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          }
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
            field: 'serialNumber',
            cellEditor: 'CargoAgGridCommonInputEditor',
            width: 100
          }, {
            headerName: this.$t('SeaExport.ChargeItem'),
            field: 'chargeItemId',
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_ChargeItem,
                methodParams: { active: true },
                filterable: true,
                tagValue: 'itemId',
                tagName: 'zhName',
                filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
                filterType: 'global'
              }
            },
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PayingParty'), field: 'paymentTarget', width: 180,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            },
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Company,
                tagValue: 'cmpIdx',
                tagName: 'chineseName',
                methodParams: { active: true, airCmp: true, bookingAgent: true },
                filterable: true
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Amount'),
            colId: 'amount',
            field: 'amount',
            initialWidth: 180,
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00')
            },
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              }
            }
          }, {
            headerName: this.$t('Insurance.Charges'),
            field: 'feeStandards',
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                staticOptions: FEE_STANDARDS,
                tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
                tagValue: 'code'
              }
            },
            valueFormatter: params => {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.FEE_STANDARDS)
            },
            width: 100
          }, {
            headerName: this.$t('CargoMsg.Cargo_UnitPrice_TotalPrice'),
            field: 'unit',
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                staticOptions: UNITS,
                tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
                tagValue: 'code'
              }
            },
            valueFormatter: params => {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.UNITS)
            },
            width: 100
          },
          {
            headerName: this.$t('FinanceManage.charge_currency'),
            colId: 'currency',
            field: 'currency',
            initialWidth: 180,
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Currency,
                filterable: true,
                tagValue: 'code',
                tagName: 'code',
                filterTagNames: ['code']
              }
            }
          }
        ],
        rowData: [],
        gridApi: null
      }
    }
  },
  methods: {
    init() {
      if (this.form.voyages && this.form.voyages.length > 0) {
        this.voyageGrid.rowData = this.form.voyages.filter(voyage => voyage.active === true)
      } else {
        this.voyageGrid.rowData = this.form.voyages
      }
      // if (this.voyageGrid.rowData && this.voyageGrid.rowData.length > 0) {
      //   for (const voyage of this.voyageGrid.rowData) {
      //     if (voyage.voyage)
      //   }
      // }
    },
    voyageCostAdd() {
      // 判断是否选中数据
      if (!this.selectedItem) {
        this.$message.warning(this.$t('CargoMsg.cargo_Please_select_a_container'))
        return
      }
      const length = this.voyageCostGrid.rowData.length + 1
      const data = {
        serialNumber: length,
        chargeItemId: 0,
        paymentTarget: 0,
        feeStandards: FEE_STANDARDS_WEIGHT.code,
        amount: 0,
        unit: UNIT_PRICE.code,
        currency: CURRENCY_RMB.code
      }
      this.voyageCostGrid.rowData.push(data)
    },
    voyageCostDel() {
      const rows = this.voyageCostGrid.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.voyageCostGrid.rowData) {
        for (let i = this.voyageCostGrid.rowData.length - 1; i >= 0; --i) {
          const row = this.voyageCostGrid.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              this.delVoyageCostKeys.push(row.uuid)
            }
            this.voyageCostGrid.rowData.splice(i, 1)
          }
        }
      }
      const tempRowData = this.voyageCostGrid.rowData
      this.voyageCostGrid.rowData = []
      this.$nextTick(() => {
        // 重置序号
        for (let i = 0; i < tempRowData.length; i++) {
          const data = tempRowData[i]
          data.serialNumber = i + 1
        }
        this.voyageCostGrid.rowData = tempRowData
        this.voyageCostGrid.gridOptions.api.refreshCells({ force: true })
        this.voyageCostGrid.gridOptions.api.clearFocusedCell()
      })
    },
    // 保存前校验
    check() {
      if (this.voyageGrid.rowData && this.voyageGrid.rowData.length > 0) {
        for (const row of this.voyageGrid.rowData) {
          if (row.voyageCosts && row.voyageCosts.length > 0) {
            for (const voyageCost of row.voyageCosts) {
              if (!voyageCost.chargeItemId) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ChargeItem'))
                return false
              }
              if (!voyageCost.paymentTarget) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PayingParty'))
                return false
              }
            }
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>

</style>
